// Central clinic information. Contact details are clearly-marked placeholders
// for the CDT team to replace. Analytics + map embed are live.
export const CLINIC = {
  name: "Center Of Dental Treatment",
  shortName: "CDT",
  tagline: "Thoughtful Dentistry for Lifelong Oral Health",
  city: "Greater Noida",
  region: "Uttar Pradesh, India",
  // Contact details
  phone: "+91 83840 87616",
  phoneHref: "tel:+918384087616",
  phone2: "+91 92121 40082",
  phone2Href: "tel:+919212140082",
  whatsapp: "+91 83840 87616",
  whatsappHref: "https://wa.me/918384087616?text=Hello%20CDT%2C%20I%27d%20like%20to%20know%20more%20about%20an%20appointment.",
  email: "carolipiyush@gmail.com",
  emailHref: "mailto:carolipiyush@gmail.com",
  addressLine: "Center of Dental Treatment, Greater Noida, Uttar Pradesh, India",
  directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=28.4573297,77.5730106",
  mapPlaceUrl: "https://www.google.com/maps/search/?api=1&query=28.4573297,77.5730106",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3507.7374575312756!2d77.57301057421526!3d28.457329692017538!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cbfb653638619%3A0xc785026fdac25136!2sCenter%20of%20Dental%20Treatment%20(RCT%2C%20Implants%2C%20Zirconia%20crowns%20%2CSmile%20Designing%2C%20Wisdom%20tooth%20extractions)%2020%20years%20of%20experience!5e0!3m2!1sen!2sin!4v1783258783444!5m2!1sen!2sin",
  youtube: "https://www.youtube.com/@centerofdentaltreatment",
  hours: [
    { day: "Morning", time: "10:00 AM – 2:00 PM" },
    { day: "Evening", time: "5:00 PM – 8:00 PM" },
  ],
  hoursNote: "By prior appointment",
  emergencyNote: "For dental emergencies outside working hours, please call or WhatsApp us — we will guide you promptly.",
};

export const NAV_LINKS = [
  { label: "Services", to: "/services" },
  { label: "Digital Dentistry", to: "/digital-dentistry" },
  { label: "Oral Cancer Centre", to: "/oral-cancer-centre" },
  { label: "International Patients", to: "/international-patients" },
  { label: "Doctors", to: "/doctors" },
  { label: "Knowledge", to: "/knowledge" },
  { label: "Stories", to: "/patient-stories" },
  { label: "Contact", to: "/contact" },
];
